import { AbstractDictionary } from "./AbstractDictionary";
import { DicTroopType } from "./tsadv$DicTroopType";
import { DicTroopsStructure } from "./tsadv$DicTroopsStructure";
export class DicMilitaryRank extends AbstractDictionary {
  static NAME = "tsadv$DicMilitaryRank";
  troopType?: DicTroopType | null;
  categoryComposition?: DicTroopsStructure | null;
}
export type DicMilitaryRankViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "dicMilitaryRank-edit"
  | "dicMilitaryRank-view";
export type DicMilitaryRankView<
  V extends DicMilitaryRankViewName
> = V extends "_base"
  ? Pick<
      DicMilitaryRank,
      | "id"
      | "langValue"
      | "langValue1"
      | "langValue2"
      | "langValue3"
      | "langValue4"
      | "langValue5"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "description1"
      | "description2"
      | "description3"
      | "description4"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_local"
  ? Pick<
      DicMilitaryRank,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_minimal"
  ? Pick<
      DicMilitaryRank,
      | "id"
      | "langValue"
      | "langValue1"
      | "langValue2"
      | "langValue3"
      | "langValue4"
      | "langValue5"
    >
  : V extends "dicMilitaryRank-edit"
  ? Pick<
      DicMilitaryRank,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "company"
    >
  : V extends "dicMilitaryRank-view"
  ? Pick<
      DicMilitaryRank,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "troopType"
      | "categoryComposition"
      | "company"
    >
  : never;
